import request from "./request";

//模板
export const getAdCount = () => request("/bi/getAdvertiserInfo", null, "POST_JSON");
export const getAdertiserProduct = (data) => request("/toutiao/getAssets", data, "GET");
export const queryTemplate = (data) => request("/toutiao/queryTemplate", data, "GET");

//广告组
// export const createCampaign = (data) => request("/toutiao/createCampaign", data, "POST_JSON");
export const queryCampaign = (data) => request("/toutiao/queryCampaign", data, "POST");
export const updateCampaign = (data) => request("/toutiao/updateCampaign", data, "POST");

//基础设置
export const queryConvert = (data) => request("/toutiao/queryConvert", data, "POST");
export const getCrowdTag = (data) => request("/toutiao/getCrowdTag", data, "GET");

export const getPromotion = (data) => request("/toutiao/getPromotion", data, "GET");
export const getCallToAction = (data) => request("/toutiao/getCallToAction", data, "GET");
export const getPlayableList = (data) => request("/toutiao/playableList", data, "GET");

export const getIndustry = () => request("/toutiao/getIndustry", null, "GET");
export const saveCreativeLable = (data) => request("/toutiao/saveCreativeLable", data, "POST_JSON");
export const queryCreativeLable = () => request("/toutiao/queryCreativeLable", null, "GET");

export const queryInheritedAdvertiserId = (data) => request("/toutiao/queryInheritedAdvertiserId", data, "GET");

//获取推广卡片
export const promotionCard = (data) => request("/toutiao/promotionCard", data, "POST");
//深度目标查询
export const feedAds = (data) => request("/toutiao/feedAds", data, "GET");
//搜索快投数据
export const optimizedGoal = (data) => request("/toutiao/optimizedGoal", data, "GET");
//获取落地页
export const getSitePage = (data) => request("/toutiao/getSitePage", data, "GET");

//定向包
export const getPackParams = (data) => request("/toutiao/getPackParams", data, "GET");
export const getInterestAction = (data) => request("/toutiao/getInterestAction", data, "GET");
export const newPack = (data) => request("/toutiao/newPack", data, "POST_JSON");
export const getPack = (data) => request("/toutiao/getPack", data, "GET");
export const flowPackage = (data) => request("/toutiao/flowPackage", data, "GET");
//抖音达人相关
export const awemeCategory = (data) => request("/toutiao/awemeCategory", data, "GET");
export const awemeAuthor = (data) => request("/toutiao/awemeAuthor", data, "GET");
export const awemeSimilar = (data) => request("/toutiao/awemeSimilar", data, "GET");
export const awemeSearch = (data) => request("/toutiao/awemeSearch", data, "GET");
//预算与出价
export const newBudget = (data) => request("/toutiao/newBudget", data, "POST_JSON");
export const getBudget = (data) => request("/toutiao/getBudget", data, "GET");
// 删除预算包
export const delBudget = (data) => request("/toutiao/delBudget", data, "GET");

//创意组
export const getToutiaoId = (data) => request("/fileMgt/getToutiaoId", data, "GET");
export const getFolders = () => request("/fileMgt/getFolders", null, "GET");
export const getTag = () => request("/tag/getTag", null, "GET");
export const getDesigner = () => request("/tag/getDesigner", null, "GET");
export const getFiles = (data) => request("/fileMgt/getFiles", data, "GET");
export const saveCreativeGroup = (data) => request("/toutiao/saveCreativeGroup", data, "POST");
export const queryCreativeGroup = () => request("/toutiao/queryCreativeGroup", null, "GET");

//创意标题
export const getCreativeWord = () => request("/toutiao/getCreativeWord", null, "GET");
export const saveCreativeTitle = (data) => request("/toutiao/saveCreativeTitle", data, "POST");
export const queryCreativeTitle = (data) => request("/toutiao/queryCreativeTitle", data, "GET");
// 删除标题包
export const delCreativeTitle = (data) => request("/toutiao/delCreativeTitle", data, "GET");

//其他配置
export const getTruckUrl = (data) => request("/toutiao/getTruckUrl", data, "GET");

//提交预览
export const preview = (data) => request("/toutiao/preview", data, "POST_JSON");
export const createTemplate = (data) => request("/toutiao/createTemplate", data, "POST");
export const publish = (data) => request("/toutiao/publish", data, "GET");
// 修改头条广告组或计划状态
export const updateOpenStatus = (data) => request("/toutiao/updateOpenStatus", data, "POST_JSON");
// 建议日预算及预期成本
export const getBidSuggest = (data) => request("/toutiao/bidSuggest", data, "POST_JSON");
// 头条提交预览数据接口
export const getPreviewData = (data) => request("/toutiao/previewList", data, "GET");
// 受众预估覆盖结果
export const getEstimateAudience = (data) => request("/toutiao/estimateAudience", data, "POST_JSON");
// 获取转化管理列表
export const getConvertProductList = (data) => request("/toutiao/getConvertProductList", data, "GET");
// 获取分包产品列表
export const getExtendPackageList = (data) => request("/toutiao/getExtendPackageList", data, "GET");
// 获取广告计划可用转化目标
export const getAdConvertList = (data) => request("/toutiao/getAdConvert", data, "GET");
// 同步分包产品
export const syncExtendPackageList = (data) => request("/toutiao/syncExtendPackageList", data, "GET");

// 头条2.0
// 获取项目列表
export const getTtV2ProjectList = (data) => request("/toutiao/v2/projectList", data, "GET");
// 获取可用的产品库
export const getProductPlatform = (data) => request("/toutiao/getProductPlatform", data, "GET");
// 获取产品列表
export const getDpaDetail = (data) => request("/toutiao/getDpaDetail", data, "GET");
// 头条2.0预览
export const adPreview_ttV2 = (data) => request("/toutiao/v2/adPreview", data, "POST_JSON");
// 获取头条2.0预览信息
export const getPreviewList_ttV2 = (data) => request("/toutiao/v2/previewList", data, "GET");
// 头条2.0发布
export const adPublish_ttV2 = (data) => request("/toutiao/v2/adPublish", data, "GET");
// 出价系数
export const searchBid_ttV2 = (data) => request("/toutiao/searchBid", data, "GET");
// 获取抖音授权关系
export const getAwemeAuthList_ttV2 = (data) => request("/toutiao/AwemeAuthList", data, "GET");
// 获取账户下原生锚点
export const getNativeAnchor_ttV2 = (data) => request("/toutiao/nativeAnchor", data, "GET");
// 获取卖点列表
export const getProductSellPoint = (data) => request("/sellPointCall/sellPoint", data, "GET");
// 获取行动号召
export const getProductCallAction = (data) => request("/sellPointCall/call", data, "GET");
// 获取广告列表
export const getPromotionList_ttV2 = (data) => request("/toutiao/v2/promotionList", data, "GET");
